import { CLIENT_CONTACTS } from "../actions/types";

const initialState = {
  list: {
    isLoading: false,
    error: null,
    contacts: [],
    total: 0,
  },
  picker: {
    isLoading: false,
    isLoadingMore: false,
    error: null,
    contacts: [],
    page: 1,
    hasMore: false,
  },
  invitees: {
    byTestId: {},
  },
  tags: {
    isLoading: false,
    error: null,
    items: [], // [{id, name, usageCount}]
    fetchedAt: null,
  },
};

const emptyInvitees = { data: [], isLoading: false, error: null, fetchedAt: null };

const mergeInvitees = (state, testId, patch) => ({
  ...state,
  invitees: {
    byTestId: {
      ...state.invitees.byTestId,
      [testId]: { ...(state.invitees.byTestId[testId] || emptyInvitees), ...patch },
    },
  },
});

const clientContactsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CLIENT_CONTACTS.LIST.UPDATE:
      return { ...state, list: { ...state.list, ...payload } };

    case CLIENT_CONTACTS.LIST.LOAD:
      return { ...state, list: { ...state.list, isLoading: false, error: null, ...payload } };

    case CLIENT_CONTACTS.LIST.ERROR:
      return { ...state, list: { ...state.list, isLoading: false, ...payload } };

    case CLIENT_CONTACTS.PICKER.UPDATE:
      return { ...state, picker: { ...state.picker, ...payload } };

    case CLIENT_CONTACTS.PICKER.LOAD: {
      const { page, contacts, hasMore } = payload;
      // A row can shift across the OFFSET page boundary if a new contact is inserted between page fetches
      // (e.g. a background CSV import running while the picker is open) — dedupe by id defensively.
      const merged = page === 1 ? contacts : [...state.picker.contacts, ...contacts];
      const seen = new Set();
      const deduped = merged.filter((c) => (seen.has(c.id) ? false : seen.add(c.id)));
      return {
        ...state,
        picker: {
          ...state.picker,
          isLoading: false,
          isLoadingMore: false,
          error: null,
          page,
          hasMore,
          contacts: deduped,
        },
      };
    }

    case CLIENT_CONTACTS.PICKER.ERROR:
      return { ...state, picker: { ...state.picker, isLoading: false, isLoadingMore: false, ...payload } };

    case CLIENT_CONTACTS.PICKER.RESET:
      return { ...state, picker: initialState.picker };

    case CLIENT_CONTACTS.INVITEES.UPDATE:
      return mergeInvitees(state, payload.testId, payload.patch);

    case CLIENT_CONTACTS.TAGS.UPDATE:
      return { ...state, tags: { ...state.tags, ...payload } };

    case CLIENT_CONTACTS.TAGS.LOAD:
      return { ...state, tags: { ...state.tags, isLoading: false, error: null, fetchedAt: Date.now(), ...payload } };

    case CLIENT_CONTACTS.TAGS.ERROR:
      return { ...state, tags: { ...state.tags, isLoading: false, ...payload } };

    default:
      return state;
  }
};

export default clientContactsReducer;
